import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/web/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/web/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/web/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer({"allowComments":true});

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: SELECT Subprocessors\ndescription: Outline the subprocessors SELECT uses.\ndate: 2024-04-05T12:00:00.000Z\nhideTableOfContents: true\n---\n\n\nSELECT engages with the following third-party processors to provide the SELECT platform and related services:\n\n| Subprocessor Name                                  | Purpose                                      | Location |\n|----------------------------------------------------|----------------------------------------------| -------- |\n| [Google Cloud Platform](https://cloud.google.com/) | Cloud Hosting                                | USA      |\n| [Stripe](https://stripe.com/)                      | Payment Processing                           | USA      |\n| [Cloudflare](https://cloudflare.com)               | Content Delivery Network and DDoS Prevention | USA      |\n| [Auth0 by Okta](https://auth0.com/)                | Authentication and authorization platform    | USA      |\n| [ConvertKit](https://convertkit.com/)              | Marketing Emails                             | USA      |\n| [Bugsnag](https://bugsnag.com/)                    | Error Reporting                              | USA      |\n| [Sendgrid](https://sendgrid.com/)                  | Email Notification Services                  | USA      |\n| [Intercom](https://www.intercom.com/)              | Customer Communication                       | USA      |\n| [Pylon](https://www.usepylon.com/)                 | Customer Communication                       | USA      |\n| [Attio](https://www.attio.com/)                    | Customer Communication                       | USA      |\n| [Slack](https://www.slack.com/)                    | Internal Communication                       | USA      |\n| [Snowflake](https://www.snowflake.com/)            | Data Warehousing                             | USA      |\n| [Fivetran](https://www.fivetran.com/)              | Data Ingestion                               | USA      |\n| [Hex](https://hex.tech/)                           | Business Analytics                           | USA      |\n| [Posthog](https://posthog.com/)                    | Analytics and Monitoring                     | USA      |\n| [Hightouch](https://hightouch.com/)                | Marketing Automation                         | USA      |\n| [Anthropic](https://www.anthropic.com/)            | AI Models                                    | USA      |\n| [OpenAI](http://openai.com/)                       | AI Models                                    | USA      |\n\nFor more information, please email [security@select.dev](mailto:security@select.dev).\n";
const filepath = "/subprocessors.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens, {slots: false});

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

async function getMarkdocData(context = {}) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  // Removes undefined
  return JSON.parse(
    JSON.stringify({
      content,
      frontmatter,
      file: {
        path: filepath,
      },
    })
  );
}

export async function getStaticProps(context) {
  return {
    props: {
      markdoc: await getMarkdocData(context),
    },
  };
}

export default function MarkdocComponent(props) {
  const markdoc = props.markdoc;
  // Only execute HMR code in development
  return renderers.react(markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
